/**
 * Validazione dei valori che l'hub riceve dal server prima di usarli in `class`, `<img src>`,
 * `router.push` e link. Il backend valida già; il client non si fida comunque: un valore
 * non valido non viene mai "ripulito", viene sostituito (icona) o scartato (route, pagina).
 */
import { IMMI_ICONS } from '@/lib/immiIcons'

export const ICONA_DEFAULT = 'pi pi-cog'
const RE_ICONA_PI = /^pi pi-[a-z0-9-]+$/
const RE_IMMI = /^immi:[A-Za-z0-9_-]+$/
// Whitelist: solo caratteri semplici. Niente `%` (bloccherebbe %2e%2e, %2f), `:`, `\\`, spazi, controlli,
// bidi (U+202E), separatori di riga (U+2028/2029). I percorsi reali non hanno query: non si ammette.
const RE_PERCORSO = /^\/[A-Za-z0-9_\-/.]*$/
const RE_PAGINA_CLASSICA = /^\/[A-Za-z0-9_\-/.]+\.xhtml$/
const LUNGHEZZA_MAX = 300

/** Percorso senza `//` né segmenti `.`/`..`. */
function percorsoPulito(p: string): boolean {
  return !p.includes('//') && !p.split('/').some((seg) => seg === '.' || seg === '..')
}

/** `pi pi-<nome>` oppure `immi:<chiave>` del catalogo; altrimenti l'icona di default. */
export function iconaSicura(icona: string | null | undefined): string {
  if (typeof icona !== 'string') return ICONA_DEFAULT
  if (RE_ICONA_PI.test(icona)) return icona
  if (RE_IMMI.test(icona) && IMMI_ICONS.some((i) => `immi:${i.key}` === icona)) return icona
  return ICONA_DEFAULT
}

/** Solo la classe `pi pi-…` (dove un'immagine non si può mostrare, es. la palette). */
export function iconaClasseSicura(icona: string | null | undefined): string {
  const i = iconaSicura(icona)
  return i.startsWith('immi:') ? ICONA_DEFAULT : i
}

/** Percorso interno del portale nuovo: whitelist `/[A-Za-z0-9_-/.]*`, ≤ 300, senza `//` né segmenti `.`/`..`. */
export function routeSicura(route: string | null | undefined): string | null {
  if (typeof route !== 'string' || route.length === 0 || route.length > LUNGHEZZA_MAX) return null
  return RE_PERCORSO.test(route) && percorsoPulito(route) ? route : null
}

/** Pagina del classico: `/pages/…/Nome.xhtml` (niente query), stessa whitelist e pulizia dei segmenti. */
export function paginaClassicaSicura(pagina: string | null | undefined): string | null {
  if (typeof pagina !== 'string' || pagina.length > LUNGHEZZA_MAX) return null
  return RE_PAGINA_CLASSICA.test(pagina) && percorsoPulito(pagina) ? pagina : null
}
